import { configureStore, combineReducers } from '@reduxjs/toolkit';
import gameReducer from './gameSlice';
import animationReducer from './animationSlice';
import overlayReducer from './overlaySlice';
import tutorialReducer from './tutorialSlice';
import trailerReducer from './trailerSlice';

const resetInterceptor = reducers => (state, action) => {
    if (action.type === "game/join" || action.type === "trailer/startTrailer") {
        state = undefined;
    }

    return reducers(state, action);
}

export default configureStore({
    reducer: resetInterceptor(combineReducers({
        game: gameReducer,
        animation: animationReducer,
        overlay: overlayReducer,
        tutorial: tutorialReducer,
        trailer: trailerReducer,
    })),
});
